module.exports = __webpack_public_path__ + "static/media/logo-big.ae8ef0d9.svg";